import SentimentVeryDissatisfiedIcon from '@material-ui/icons/SentimentVeryDissatisfied';

import SymptomCreate from './create';
import SymptomList from './list';
import SymptomShow from './show';
import SymptomEdit from './edit';

export default {
    create: SymptomCreate,
    list: SymptomList,
    show: SymptomShow,
    edit: SymptomEdit,
    icon: SentimentVeryDissatisfiedIcon
};